  <div class="view-email-configuration" *ngIf="!editForm">
    <div class="row">
      <label class="col-4" i18n="@@serviceEmailConfigDetailPrefix">Email Service:</label>
      <div class="col-8 col-value">{{ getEmailServiceLabel() }}</div>
    </div>
    <div *ngIf="user.paramValues.mailMode === 'smtp'">
      <div class="row">
        <label class="col-4" i18n="@@smtpHostConfigDetailPrefix">SMPT Host:</label>
        <div class="col-8 col-value">{{ user.paramValues.smtpHost }}</div>
      </div>
      <div class="row">
        <label class="col-4" i18n="@@smtpPortEmailConfigDetailPrefix">Port:</label>
        <div class="col-8 col-value">{{ user.paramValues.smtpPort }}</div>
      </div>
      <div class="row">
        <label class="col-4" i18n="@@smtpEmailConnectionSecurityConfigDetailPrefix">Connection Security:</label>
        <div class="col-8 col-value">{{ getEmailEncryptionProtocol() }}</div>
      </div>
      <div class="row">
        <label class="col-4" i18n="@@smtpEmailUserConfigDetailPrefix">User:</label>
        <div class="col-8 col-value">{{ user.paramValues.smtpUser }}</div>
      </div>
      <div class="row">
        <label class="col-4" i18n="@@smtpEmailOriginConfigDetailPrefix">Sender Email:</label>
        <div class="col-8 col-value">{{ user.paramValues.smtpEmailFrom }}</div>
      </div>
    </div>
    <div class="row" *ngIf="user.paramValues.mailMode !== 'smtp'">
      <label class="col-4" i18n="@@senderNameEmailConfigDetailPrefix">Sender Name:</label>
      <div class="col-8 col-value">{{ user.paramValues.mailNameLabel || "ReportsFeed" }}</div>
    </div>
  </div>
  <div class="edit-email-configuration" *ngIf="editForm">
    <form [formGroup]="editForm">
      <div class="row">
        <label class="col-4" i18n="@@mailModeFormConfigDetailPrefix">Email Service:</label>
        <div class="col-8 col-value">
          <select class="form-control" formControlName="mailMode" (change)="setupEditForm()">
            <option value="default">{{ mailModeOptionLabelRecord["default"] }}</option>
            <option value="smtp">{{ mailModeOptionLabelRecord["smtp"] }}</option>
          </select>
        </div>
      </div>
      <div *ngIf="editFormMode === 'smtp'">
        <div class="row">
          <label class="col-4" i18n="@@smtpHostConfigDetailPrefix">SMTP Host:</label>
          <div class="col-8 col-value"><input type="text" class="form-control" formControlName="smtpHost" [readonly]="isFormDisabled" /></div>
        </div>
        <div class="row">
          <label class="col-4" i18n="@@smtpPortEmailConfigDetailPrefix">Port:</label>
          <div class="col-8 col-value"><input type="text" class="form-control" formControlName="smtpPort" [readonly]="isFormDisabled" /></div>
        </div>
        <div class="row">
          <label class="col-4" i18n="@@smtpEmailConnectionSecurityConfigDetailPrefix">Connection Security:</label>
          <div class="col-8 col-value">
            <select class="form-control" formControlName="smtpIsSafe">
              <option value="0">{{ securityOptionLabelRecord[0] }}</option>
              <option value="1">{{ securityOptionLabelRecord[1] }}</option>
              <option value="2">{{ securityOptionLabelRecord[2] }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <label class="col-4" i18n="@@smtpEmailUserConfigDetailPrefix">User:</label>
          <div class="col-8 col-value"><input type="text" class="form-control" formControlName="smtpUser" [readonly]="isFormDisabled" /></div>
        </div>
        <div class="row">
          <label class="col-4" i18n="@@smtpEmailPasswordConfigDetailPrefix">Pass:</label>
          <div class="col-8 col-value"><input type="password" class="form-control" formControlName="smtpPassword" [readonly]="isFormDisabled" /></div>
        </div>
        <div class="row">
          <label class="col-4" i18n="@@smtpEmailOriginConfigDetailPrefix">Sender Email:</label>
          <div class="col-8 col-value"><input type="text" class="form-control" formControlName="smtpEmailFrom" [readonly]="isFormDisabled" /></div>
        </div>
        <div class="row smtp-result" *ngIf="!smtpTest.loading && (smtpTest.message || smtpTest.success)">
          <div class="col-12">
            <span class="error-message" *ngIf="smtpTest.message">{{ smtpTest.message }}</span>
            <span class="success-message" *ngIf="!smtpTest.message && smtpTest.success" i18n="@@successfullyConnectedSMTPServerNotice">Successfully communicated with the SMTP server!</span>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="editFormMode == 'default'">
        <label class="col-4" i18n="@@senderNameConfigDetailPrefix">Sender Name:</label>
        <div class="col-8 col-value"><input type="text" class="form-control" formControlName="mailNameLabel" [readonly]="isFormDisabled" /></div>
      </div>
      <div class="row" *ngIf="formErrors">
        <div class="offset-1 col-10 alert alert-danger" *ngFor="let error of formErrors">{{ error }}</div>
      </div>
      <div class="row">
        <div class="col-12 actions" style="padding-right: 22px;">
          <button *ngIf="editFormMode === 'smtp'" class="btn btn-info btn-with-left-icon" (click)="onTestSMTPClick()" [disabled]="smtpTest.loading">
            <i class="fa fa-server" *ngIf="!smtpTest.loading"></i>
            <i class="fa fa-circle-o-notch fa-spin" *ngIf="smtpTest.loading"></i>
            <span i18n="@@testSMTPConfigButtonLabel">Test SMTP Configuration</span>
          </button>
          <button
            role="button"
            type="button"
            class="btn btn-danger"
            [disabled]="isFormLoading"
            (click)="onCancelClick()"
            i18n="generic button label to cancel or close|A generic button label to close or cancel a form without saving nor submitting the changes@@genericCloseButton"
          >Close</button>
          <button
            role="button"
            type="button"
            class="btn btn-primary"
            [disabled]="isFormLoading"
            (click)="onSubmitClick()"
            i18n="generic button label to save or submit|A generic button label to save or submit a form, sending the changes to the server@@genericSaveButton"
          >Save</button>
        </div>
      </div>
    </form>
  </div>
